import { InputField } from "components/TextInput"
import { useFormik } from "formik"
import authStore from "mobx/AuthStore"
import React, { useState } from "react"
import { CtaMemo, } from "./style"
import { Modal } from "antd"

export default function LoanActionButton ({
	isActive,
	amount,
	btnText,
	bg,
	handleSubmit,
	validationSchema,
	modalTitle,
	modalDescription,
	disabled=false
	}){
	const [open,setOpen] = useState(false)
	const toggleModal = ()=>{
		setOpen(!open)
	}
	const closeModal = ()=>setOpen(false)
	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			comment: "",
			amount,
		},
		onSubmit:(data,helpers)=>handleSubmit(data,helpers,closeModal),
		validationSchema: validationSchema
	})

	if(isActive){
		return(
			<>
				<button style={{background:(bg || "#66BB6A")}} onClick={toggleModal} className="btn-modal p-4 py-2 rounded-md text-white font-poppins">{btnText}</button>
				{open && (
					<Modal open={open} onCancel={toggleModal} footer={null}>
					<div className="modal">
						{/* <div className="overlay"></div> */}

						<form className="modal-content" onSubmit={formik.handleSubmit}>
							<div className="p-3">
								<header className="mb-6">
									<p className="text-2xl font-semibold">{modalTitle}</p>
									{modalDescription && (
										<p className="text-sm text-gray-600">{modalDescription}</p>
									)}
								</header>
								{/* <p>{action === "approved" ? "If yes, leave a comment below and proceed" : ""}</p> */}
								<InputField
									label="Amount"
									name="amount"
									id="amount"
									disabled={disabled}
									style={{marginBottom:"16px",opacity:disabled?"0.5":null}}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.amount}
									error={formik.errors.amount}
									visible={formik.touched.amount}
									placeholder="Amount"
								/>
								<CtaMemo required name="comment" id="comment" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.comment}>
									Write a memo here...
								</CtaMemo>{" "}
								<button className="bg-primary text-white px-4 font-medium py-2 rounded-lg" type="submit">{authStore?.isLoading ? "Loading..." : "Proceed"}</button>
							</div>
						</form>
					</div>
				</Modal>
				)}
			</>
		)
	}
	return null
}